module.exports = __webpack_public_path__ + "img/attic.be5030ca.webp";